import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Spinner } from './components/ui';
import { AuthProvider, useAuth } from './lib/auth';
import { AIUsage } from './pages/AIUsage';
import { Analytics } from './pages/Analytics';
import { Ask } from './pages/Ask';
import { CampaignDetail } from './pages/CampaignDetail';
import { Campaigns } from './pages/Campaigns';
import { CompanyDetail } from './pages/CompanyDetail';
import { Companies } from './pages/Companies';
import { Dashboard } from './pages/Dashboard';
import { GmailContacts } from './pages/GmailContacts';
import { Guide } from './pages/Guide';
import { Login } from './pages/Login';
import { Pipeline } from './pages/Pipeline';
import { Posts } from './pages/Posts';
import { ProspectDetail } from './pages/ProspectDetail';
import { Prospects } from './pages/Prospects';
import { Queue } from './pages/Queue';
import { Replies } from './pages/Replies';
import { Settings } from './pages/Settings';
import { Today } from './pages/Today';

function Routing() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-ink-400">
        <Spinner className="h-6 w-6" />
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="today" element={<Today />} />
        <Route path="prospects" element={<Prospects />} />
        <Route path="prospects/:id" element={<ProspectDetail />} />
        <Route path="companies" element={<Companies />} />
        <Route path="companies/:id" element={<CompanyDetail />} />
        <Route path="pipeline" element={<Pipeline />} />
        <Route path="queue" element={<Queue />} />
        <Route path="replies" element={<Replies />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="campaigns/:id" element={<CampaignDetail />} />
        <Route path="posts" element={<Posts />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="ask" element={<Ask />} />
        <Route path="ai-usage" element={<AIUsage />} />
        <Route path="gmail-contacts" element={<GmailContacts />} />
        <Route path="settings" element={<Settings />} />
        <Route path="guides" element={<Guide />} />
        <Route path="guides/:slug" element={<Guide />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routing />
      </AuthProvider>
    </BrowserRouter>
  );
}
